import Paper from '@/components/Paper'
import SubHeaders from '@/components/Headers/SubHeaders'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { FilterBar } from '@/components/ui/data-table-customized'
import AddIcons from '@/icons/AddIcons'
import { paths } from '@/utils/path'
import { IPermissionProps } from '@/types/shared'

import { useHolidayList } from '../../hooks/use-holiday-list'

const HolidayList: React.FC<IPermissionProps> = () => {
    const {
        holidays,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        searchInputProps,
        columns,
        actions,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        navigate,
        t,
    } = useHolidayList()

    return (
        <div className="space-y-2">
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: t('holiday-create'),
                        variant: 'contained',
                        onClick: () => navigate(paths.workdayHolidayCreate),
                    },
                ]}
                breadcrumbs={[
                    {
                        path: paths.workdayManage,
                        title: t('workday-list'),
                    },
                    {
                        path: paths.workdayHoliday,
                        title: t('holiday-list'),
                    },
                ]}
            />

            <Paper className="space-y-2">
                <FilterBar
                    storageKey="holiday-list"
                    control={control}
                    setFilter={setFilter}
                    hideSearch
                    items={filterItems}
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={holidays}
                        rowKey={(row) => row.holiday_id}
                        resizable
                        size="small"
                        actions={actions}
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('holiday-search'),
                            },
                            settings: {
                                show: true,
                                storageKey: 'holiday-list',
                                filterToggles,
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default HolidayList
